module.exports = __webpack_public_path__ + "media/application/images/icons/topics-food-waste-pebble-dark-green-rgb-7d9e18101e45e659141114599bd27de3.svg";